export default "__VITE_ASSET__BFSrxQ0I__"